export default {
  default: () => import("/var/lib/jenkins/workspace/Master/layouts/default.vue")
}